import React from "react";

// "Ready to Grow Your Business?" free-demo section from the launch-package page,
// shared with the business page.

const FREE_DEMO_IMAGES = [
  "/images/launch/free-demo-handshake-top.webp",
  "/images/launch/free-demo-gift-handshake.webp",
  "/images/launch/free-demo-headset-thumbsup.webp",
  "/images/launch/free-demo-pink-hair-woman.webp",
  "/images/launch/free-demo-pie-chart-team.webp",
  "/images/launch/free-demo-window-fistbump.webp",
];

const FREE_DEMO_URL = "https://calendar.app.google/8zDqrfCsSnWoLYUj9";

export const FreeDemoSection: React.FC = () => {
  return (
    <section className="w-full py-20 md:py-28 bg-[#FBF1EF]">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="bg-white rounded-[40px] overflow-hidden flex flex-col lg:flex-row items-stretch">
          <div className="w-full lg:w-[52%] px-8 sm:px-12 lg:px-16 py-16 lg:py-24 flex flex-col justify-center">
            <h2 className="text-[#2A2A2A] text-[40px] sm:text-[52px] min-[1442px]:text-[45px] min-[1442px]:sm:text-[59px] leading-[1.1] font-medium">
              Ready to Grow
              <br />
              <span className="text-[#E00000] font-extrabold">Your Business?</span>
            </h2>
            <p className="mt-6 text-[#3A3A3A] text-[17px] min-[1442px]:text-[19px] leading-relaxed max-w-[480px]">
              Book A Free Demo To See How Founding Membership Helps You Get Discovered, Reach More
              Customers, And Build Lasting Business Growth.
            </p>
            <a
              href={FREE_DEMO_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-8 self-start inline-flex items-center justify-center bg-[#2A2A2A] text-white text-[16px] min-[1442px]:text-[18px] font-semibold rounded-2xl px-8 py-4 hover:bg-black transition"
            >
              Get a free demo
            </a>
          </div>

          <div className="hidden lg:grid w-full lg:w-[48%] grid-cols-2 gap-5 p-6">
            <div className="grid grid-rows-[0.7fr_1.3fr_1fr] gap-5 min-h-0">
              <div className="rounded-[28px] overflow-hidden min-h-0">
                <img src={FREE_DEMO_IMAGES[0]} alt="" className="w-full h-full object-cover" />
              </div>
              <div className="rounded-[28px] overflow-hidden min-h-0">
                <img src={FREE_DEMO_IMAGES[1]} alt="" className="w-full h-full object-cover" />
              </div>
              <div className="rounded-[28px] overflow-hidden min-h-0">
                <img src={FREE_DEMO_IMAGES[2]} alt="" className="w-full h-full object-cover" />
              </div>
            </div>
            <div className="grid grid-rows-[1fr_1.2fr_0.6fr] gap-5 min-h-0 mt-16 mb-[-56px]">
              <div className="rounded-[28px] overflow-hidden min-h-0">
                <img src={FREE_DEMO_IMAGES[3]} alt="" className="w-full h-full object-cover" />
              </div>
              <div className="rounded-[28px] overflow-hidden min-h-0">
                <img src={FREE_DEMO_IMAGES[4]} alt="" className="w-full h-full object-cover" />
              </div>
              <div className="rounded-[28px] overflow-hidden min-h-0">
                <img src={FREE_DEMO_IMAGES[5]} alt="" className="w-full h-full object-cover" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};